module.exports = __webpack_public_path__ + "static/media/catalog-pro.1c93b493.svg";